/* eslint react/jsx-no-bind:0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

const styles = {
  searchBoxInput: {
    background: 'transparent',
    border: 0,
    borderRadius: '3px',
    boxShadow: 'none',
    boxSizing: 'border-box',
    fontSize: '16px',
    fontWeight: '600',
    height: '40px',
    lineHeight: '20px',
    overflow: 'hidden',
    width: '100%',
  },
};

export default class SearchBoxInput extends Component {
  static propTypes = {
    autoComplete: PropTypes.oneOf(['on', 'off']),
    cursorPosition: PropTypes.number,
    disabled: PropTypes.bool,
    focused: PropTypes.bool,
    id: PropTypes.string,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    onFocus: PropTypes.func,
    onKeyDown: PropTypes.func,
    placeholder: PropTypes.string,
    type: PropTypes.oneOf(['url', 'text', 'password']),
    value: PropTypes.string,
  };

  static defaultProps = {
    type: 'text',
  };

  componentDidMount() {
    if (this.props.focused) {
      this._input.focus();
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.focused && this.props.focused) {
      this._input.focus();
      if (this.props.cursorPosition) {
        this._input.setSelectionRange(this.props.cursorPosition, this.props.cursorPosition);
      }
    } else if (!this.props.focused) {
      this._input.blur();
    }
  }

  handleChange = (e) => {
    if (this.props.onChange) {
      return this.props.onChange(e.target.value);
    }
    return null;
  };

  render() {
    return (
      <input
        autoComplete={this.props.autoComplete}
        className={'OpenSearchBoxInput'}
        disabled={this.props.disabled ? 'disabled' : ''}
        id={this.props.id}
        name={this.props.name}
        onBlur={this.props.onBlur ? this.props.onBlur.bind(this) : null}
        onChange={this.handleChange}
        onClick={this.props.onClick ? this.props.onClick.bind(this) : null}
        onFocus={this.props.onFocus ? this.props.onFocus.bind(this) : null}
        onKeyDown={(e) => {
          this.props.onKeyDown(e);
        }}
        placeholder={this.props.placeholder}
        ref={(comp) => {
          this._input = comp;
        }}
        style={styles.searchBoxInput}
        type={this.props.type}
        value={this.props.value || ''}
      />
    );
  }
}
